var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "dg-tab-select" },
    [
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.show } },
        [
          _vm._t("default", function () {
            return [_vm._v("选择数据库表")]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "dg-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "append-to-body": "",
            top: "60px",
            title: "数据库表选择",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            confirm: _vm.handleConfirm,
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "dg-form",
            {
              ref: "form",
              staticClass: "select-form",
              attrs: {
                "form-data": _vm.form,
                "form-items": _vm.items,
                "label-width": "180px",
              },
              on: {
                "update:formData": function ($event) {
                  _vm.form = $event
                },
                "update:form-data": function ($event) {
                  _vm.form = $event
                },
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.tableItem.label, prop: "tableSelected" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: _vm.multiple,
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: "请输入表名称关键词查询",
                        "remote-method": _vm.handleTableSearch,
                        loading: _vm.tableItem.loading,
                        disabled: _vm.tableItem.disabled,
                      },
                      model: {
                        value: _vm.form.tableSelected,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "tableSelected", $$v)
                        },
                        expression: "form.tableSelected",
                      },
                    },
                    _vm._l(_vm.tableItem.selectOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "已选择数据库表" } },
                [
                  !_vm.layoutSelected.length
                    ? _c("span", { staticClass: "empty-tip" }, [
                        _vm._v("暂未选择数据库表"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.layoutSelected, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag,
                        staticStyle: { "margin-right": "6px" },
                        attrs: { closable: "" },
                        on: {
                          close: function ($event) {
                            return _vm.handleDeleteSelected(tag)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(tag.split("|").pop()) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }